export default __webpack_public_path__ + "static/media/img.490719ed.png";